// global routes.tsx
import { Route } from "react-router-dom";
import { PublicEventSeriesPage } from "../components/event-series/pages/public-event-series-page";

export const GlobalRoutes = [
  <Route key="event-series-public-page" path="/events/:seriesId" element={<PublicEventSeriesPage />} />,
];
